import React from "react";

import WidgetUUIDContext from "contexts/WidgetUUIDContext";

/**
 * This hook return the UUID of the widget stored in the WidgetUUIDContext context.
 */
const useWidgetUUID = () => {
  const context = React.useContext(WidgetUUIDContext);

  if (context === undefined) {
    throw new Error("useWidgetUUID must be used within a WidgetUUIDProviderContext");
  }

  return context;
};

export default useWidgetUUID;
